/*
 * Top level layout for a single Topic
 */

define(["marionette", "modules/topicsSplit/topic/template/topicTemplate.html", "jquery"], function (
  Marionette,
  TopicTemplate,
  $,
) {
  var TopicView = {};

  TopicView.topicLayout = Marionette.Layout.extend({
    template: TopicTemplate,
    events: {
      "show #authoringTab": function (e) {
        this.trigger("show:authoring", e);
      },
      "show #conversationTab": function (e) {
        this.trigger("show:conversation", e);
      },
      "show #performanceTab": function (e) {
        this.trigger("show:performance", e);
      },
      "show #surveyTab": function (e) {
        this.trigger("show:survey", e);
      },
      "show #tasksTab": function (e) {
        this.trigger("show:tasks", e);
      },
    },
    regions: {
      title: "#title",
      context: "#context",
      status: "#status",
      scheduledStatus: "#scheduledStatus",
      details: "#details",
      folder: "#folder",
      label: "#label",
      examples: "#examples",
      conversation: "#conversation",
      performance: "#topicPerformance",
      survey: "#topicSurvey",
      advancedConversation: "#advancedConversationArea",
      tasks: "#tasksArea",
      usage: "#topicUsage",
    },
    showConversationPane: function () {
      this.$el.find("#conversationTab").tab("show");
    },
    showConversationTab: function () {
      this.$el.find("#conversationTab").parent().removeClass("hidden");
    },
    showPerformanceTab: function () {
      this.$el.find("#performanceTab").parent().removeClass("hidden");
    },
    showSurveyTab: function () {
      this.$el.find("#surveyTab").parent().removeClass("hidden");
    },
    showTab: function (tabEl) {
      $(tabEl).tab("show");
    },
    showTasks: function () {
      this.$el.find("#tasksTab").parent().removeClass("hidden");
    },
    triggers: {
      "click #deleteTopic": "delete:topic",
      "click #addTopic": "add:another:topic",
      "click #discardTopicChanges": "discard:topic:changes",
      "click #history": "topic:history",
      "click #archiveTopic": "archive:topic",
      "click #restoreTopic": "restore:topic",
      "click #saveTopic": "save:topic",
    },
    updateTaskCount: function (count) {
      if (count > 0) {
        this.$el.find("#tasksTab").html($.t("topic.tabs.tasksWithCount", { count: count }));
      } else {
        //plain-old "Tasks"
        this.$el.find("#tasksTab").html($.t("topic.tabs.tasks"));
      }
    },
  });

  return TopicView;
});
